<template>
  <div class="main-body">
    <div class="header">活动记录</div>
    <div class="out">

      <div class="search2">
        <el-button type="primary" plain size="mini" @click.native="toggleModalAdd">添加</el-button>

<!--        <div style="float:right;">-->

<!--          <el-select v-model="commandCenterCode" placeholder="请选择机构">-->
<!--            <el-option-->
<!--                v-for="item in arr_comm"-->
<!--                :key="item.commandCenterCode"-->
<!--                :label="item.name"-->
<!--                :value="item.commandCenterCode">-->
<!--            </el-option>-->
<!--          </el-select>-->

<!--          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>-->

<!--        </div>-->

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="activityContentName" label="活动内容" fixed width="150"></el-table-column>

        <el-table-column prop="practiceSiteName" label="实践中心" width="150"></el-table-column>
        <el-table-column prop="volunteerTeamName" label="志愿队伍" width="150"></el-table-column>

        <el-table-column prop="activityAddress" label="活动地址" width="250"></el-table-column>
        <el-table-column prop="activityStartTime" :formatter="timefilter" label="开始时间" width="180"></el-table-column>
        <el-table-column prop="activityEndTime" :formatter="timefilter" label="结束时间"  width="180"></el-table-column>

        <el-table-column prop="elderlyCount" label="参与人数"  width="100"></el-table-column>

        <el-table-column prop="evaluate" label="评价"  width="200"></el-table-column>
        <el-table-column prop="isShow" label="活动状态" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status ==1">点单</span>
            <span v-if="scope.row.status ==2">派单</span>
            <span v-if="scope.row.status ==3">接单</span>
            <span v-if="scope.row.status ==4">活动开始</span>
            <span v-if="scope.row.status ==5">活动结束</span>
            <span v-if="scope.row.status ==6">已评价</span>
          </template>
        </el-table-column>
        <el-table-column prop="isShow" label="对外展示" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.isShow ==1">展示</span>
          </template>
        </el-table-column>


        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">

            <el-button type="text" size="mini" @click="toggleModalEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handlePhoto(scope.$index, scope.row)">照片</el-button>
            <el-button type="text" size="mini" @click="handleEvaluate(scope.$index, scope.row)">评价</el-button>

            <el-button type="text" size="mini" v-if="scope.row.isShow==0" @click="handleShow(scope.$index, scope.row)">展示</el-button>
            <el-button type="text" size="mini" v-if="scope.row.isShow==1" @click="handleShow(scope.$index, scope.row)">隐藏</el-button>



            <el-button type="text" size="mini" @click="openQr(scope.row)">签到码</el-button>
            <el-button type="text" size="mini" @click="handlePeople(scope.row)">参与人</el-button>


            <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>


          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-bind:arr_comm="arr_comm" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:arr_comm="arr_comm" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    <Photo ref="myPhoto" v-show="showModalPhoto" v-on:closePhoto="closePhoto"></Photo>
    <People ref="myPeople" v-show="showModalPeople" v-on:closePeople="closePeople"></People>

    <el-dialog title="签到二维码" :visible.sync="OpenQrCode"
        width="290px" top='30vh' class="QRCode">
      <div class="canvas-code" id="qrcode"></div>
    </el-dialog>

    <Evaluate ref="myEvaluate" v-show="showModalEvaluate" v-on:closeEvaluate="showModalEvaluate=false" v-on:getList="getList"></Evaluate>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";


import Add from "./Add";
import Edit from "./Edit";
import People from "./People2";
import Photo from "../CommandCenter/Photo";
import QRCode from "qrcodejs2";
import Evaluate from "./Evaluate";

export default {
  name: "Page",

  data(){
    return{

      OpenQrCode: false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalAdd:false,
      showModalEdit:false,
      showModalPhoto:false,
      showModalPeople:false,
      showModalEvaluate:false,

      th:0,

      arr_comm:[],
      commandCenterCode: '',

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Photo,Add,Edit,People,Evaluate,
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{



    getComm(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CommandCenter/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_comm = response.data.data.list;
          if(this.arr_comm.length>0){
            this.commandCenterCode = this.arr_comm[0].commandCenterCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    timefilter(row,index,column){
      return timefilters(column).slice(0,16)
    },


    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalEdit:function(index, row){
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    handlePhoto(index, row) {
      this.$refs.myPhoto.init(row);
      this.showModalPhoto = !this.showModalPhoto;
    },
    closePhoto:function(){
      this.showModalPhoto = !this.showModalPhoto;
    },

    handlePeople(row) {
      this.$refs.myPeople.init(row);
      this.showModalPeople = !this.showModalPeople;
    },
    closePeople:function(){
      this.showModalPeople = !this.showModalPeople;
    },



    search(){
      this.currentPage = 1;
      this.getList();
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/GovPage2',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          //commandCenterCode:this.commandCenterCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,

        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    openQr(row) {
      this.OpenQrCode = true;
      if (document.getElementById("qrcode")) {
        document.getElementById("qrcode").innerHTML = "";
      }
      this.$nextTick(function () {
        this.qrcodeInit(row);
      })
    },
    //生成二维码
    qrcodeInit(row) {
      new QRCode('qrcode', {
        width: 250,
        height: 250,// 高度
        text: "activityOrderCode:"+row.activityOrderCode,// 二维码内容
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      })
    },


    handleShow(index,row){

      let tag = 1;
      let title = "确定对外展示吗";
      if(row.isShow == 1){
        tag = 0;
        title = "确定对外隐藏吗";
      }

      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setShow(row.activityOrderCode,tag);
      }).catch(e=>e)

    },
    setShow(activityOrderCode,isShow){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/Show',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityOrderCode:activityOrderCode,
          isShow:isShow,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.getList();
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    handleEvaluate(index,row){
      this.$refs.myEvaluate.init(row);
      this.showModalEvaluate = !this.showModalEvaluate;
    },


    handleDelete(index,row){
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "ActivityOrder/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            activityOrderCode:row.activityOrderCode,
          }
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {

            this.getList();

          } else if (response.data.error == 1) {
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(e => e)
    },


  }
}
</script>

<style scoped>

</style>
